module.exports = __webpack_public_path__ + "img/1.722a94e3.jpg";